import React from 'react';
import { Dialog } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import { Types } from "../../constants/index.js";
export default function FirmwareReleaseActionDialog(props) {
  const {
    onClose,
    show,
    onSubmit,
    actionName,
    target
  } = props;
  const onOkay = async () => {
    await onSubmit();
    onClose();
  };
  return /*#__PURE__*/React.createElement(Dialog.Question, {
    show: show,
    onClose: onClose,
    title: `${actionName} ${Attributes.get('name', Types.firmwareRelease, target?.data)}`
    // eslint-disable-next-line max-len
    ,
    message: `Are you sure you want to ${actionName} release ${Attributes.get('name', Types.firmwareRelease, target?.data)}?`,
    okay: actionName,
    onCancel: onClose,
    onOkay: onOkay
  });
}